import React from "react";
import { useTranslation } from "react-i18next";
import { useCurrentUser } from "utils/hooks";
import PlanSelection from "components/elements/PlanSelection/PlanSelection";
import "./SubscriptionSettings.styles.scss";

const SubscriptionSettings = () => {
  const { t } = useTranslation(["common"]);
  const { user: currentUser } = useCurrentUser();

  return (
    <section className="settings-section" id="subscription-settings">
      <h2 className="section-title">
        {t("settings.subscription_settings_label")}
      </h2>
      <hr className="divider" />
      <div className="subscription-settings">
        <PlanSelection
          organizationId={currentUser?.activeOrganizationId || ""}
        />
      </div>
    </section>
  );
};

export default SubscriptionSettings;
